import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAgentVerificationDecisionContext } from '../../../../useAgentVerificationDecisionContext/useAgentVerificationDecisionContext'

import { ReactComponent as SuccessIcon } from '@percent/admin-dashboard/common/assets/images/success.svg'
import { PercentButton } from '@percent/admin-dashboard/common/components'
import { Box, Typography } from '@percent/lemonade'
import styles from './AgentVerificationApprovedInformation.module.scss'
import { AgentVerificationApprovedInformationProps } from './AgentVerificationApprovedInformation.types'

export function AgentVerificationApprovedInformation({
  handleClick,
  agentFullName
}: AgentVerificationApprovedInformationProps) {
  const { t } = useTranslation()
  const { setOpenedModal } = useAgentVerificationDecisionContext()

  const handleDoneClick = () => {
    setOpenedModal(undefined)
    handleClick()
  }

  return (
    <Box className={styles.wrapper}>
      <SuccessIcon className={styles.icon} />
      <Typography variant="h2" className={styles.title}>
        {t('typography.approve.information')}
      </Typography>
      <Box className={styles.subtitleWrapper}>
        <Typography variant="large" className={styles.subtitle}>
          {agentFullName} {t('typography.approve.partialInformation')}
        </Typography>
      </Box>
      <PercentButton title={t('button.done')} onClick={handleDoneClick} className={styles.button} />
    </Box>
  )
}
